import React, { Component } from 'react';
import { Layout, Menu, message, Icon, Dropdown } from 'antd';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import './main.less';

const { Header, Sider, Content } = Layout;

const menuData = [
  { name: '商品管理', url: '/main/list', icon: 'appstore' },
  { name: '发货订单管理', url: '/main/deliverylist', icon: 'folder' },
  { name: '商品类型管理', url: '/main/typelist', icon: 'project' },
  { name: '品牌管理', url: '/main/brandlist', icon: 'cluster' },
  { name: '库存管理', url: '/main/inventorylist', icon: 'shop' },
  { name: '设备管理', url: '/main/facilitylist', icon: 'robot' },
  { name: '套餐管理', url: '/main/packagelist', icon: 'database' },
  { name: '充值管理', url: '/main/topuplist', icon: 'red-envelope' }
];

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      siderCollapsed: false,
      login_name: ''
    };
  }
  componentWillMount() {
    //验证是否需要登录
    if (window.common.loginOut(this)) {
      if (JSON.parse(window.localStorage.getItem('headParams')) !== null) {
        this.setState({
          login_name: JSON.parse(window.localStorage.getItem('headParams')).login_name
        });
      }
    } else {
      message.error('登录信息失效，请重新登录');
    }
  }

  onSiderCollapse = (collapsed) => {
    this.setState({ siderCollapsed: collapsed });
  };

  // 登出
  loginOutEvent = () => {
    window.api('eps.logout', {login_name: this.state.login_name}).then(res => {
      res.service_status === 'S' ? this.props.history.push({pathname: '/login'}) : null;
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
    window.localStorage.clear();
  }

  render() {
    const { redirect, siderCollapsed, login_name } = this.state;
    const pathname = this.props.location ? this.props.location.pathname : '';

    const userMenu = (
      <Menu className="header-user-menu">
        <Menu.Item key="user" disabled>
          <Icon type="user" /> {login_name}
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="logout" onClick={this.loginOutEvent}>
          <Icon type="logout" /> 退出登录
        </Menu.Item>
      </Menu>
    );

    if (redirect) {
      return <Redirect to="/login" />;
    }

    return (
      <Layout className="main-layout">
        <Header className="header">
          <div className="header-left">
            <Link to="/main/list" className="header-logo">
              <span className="header-logo-text">数字商业平台</span>
            </Link>
          </div>
          <div className="header-right">
            <Dropdown overlay={userMenu} trigger={['click']} placement="bottomRight">
              <span className="header-user">
                <Icon type="user" className="header-user-icon" />
                <span className="header-user-name">{login_name || '用户'}</span>
                <Icon type="down" className="header-user-arrow" />
              </span>
            </Dropdown>
          </div>
        </Header>
        <Layout className="main-body">
          <Sider
            breakpoint="lg"
            collapsedWidth={0}
            collapsible
            collapsed={siderCollapsed}
            onCollapse={this.onSiderCollapse}
            className="main-sider"
            width={220}
          >
            
            <Menu
              mode="inline"
              theme="light"
              selectedKeys={[pathname]}
              className="main-menu"
              style={{ height: '100%', borderRight: 0 }}
            >
              {menuData.map(item => (
                <Menu.Item key={item.url}>
                  <Link to={item.url}>
                    <Icon type={item.icon} />
                    <span>{item.name}</span>
                  </Link>
                </Menu.Item>
              ))}
            </Menu>
          </Sider>
          <Content className="main-content">
            <div className="main-content-inner">{this.props.children}</div>
          </Content>
        </Layout>
      </Layout>
    );
  }
}
export default Main;



// WEBPACK FOOTER //
// ./src/containers/backEnd/main/main.jsx